import { reactive, toRefs } from '@vue/composition-api'

export default () => {
  const data = reactive({
    data: [], // 表格数据
    waitItem: null, // 用于编辑或者删除等二次确认的缓存字段
    visible: false, // 一般添加弹窗
    loading: false, // 表格loaing/局部加载loading
    isEdit: false, // 是否编辑
    // 用于表格显示分页的配置信息（支持扩展）
    pagination: {
      current: 1,
      pageSize: 10,
      'show-quick-jumper': true,
      'show-size-changer': true,
      defaultPageSize: 10,
      total: 10
    }
  })

  function handleTableChange(page, filters, sorter) {
    const { current, pageSize } = page
    this.pagination.current = current
    this.pagination.pageSize = pageSize
    this.searchForm.page = current
    this.searchForm.per_page = pageSize
    this.getList()
  }

  return {
    ...toRefs(data),
    handleTableChange
  }
}
